import { z } from 'zod';

// Zod schema for type-safe validation
const ResourceRequestSchema = z.object({
  title: z.string().min(3),
  description: z.string().min(10),
  urgency: z.enum(['low', 'medium', 'high']),
  requiredBy: z.date().optional(),
});

export type ResourceRequestInput = z.infer<typeof ResourceRequestSchema>;

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

export async function createResourceRequest(
  input: ResourceRequestInput
): Promise<ApiResponse<unknown>> {
  try {
    // Validate input with Zod
    const validatedData = ResourceRequestSchema.parse(input);
    
    const response = await fetch('/api/resource-requests', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(validatedData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    return { success: true, data };
  } catch (error) {
    if (error instanceof z.ZodError) {
      return { 
        success: false, 
        error: `Validation failed: ${error.errors.map(e => e.message).join(', ')}` 
      };
    }
    
    const message = error instanceof Error ? error.message : 'Unknown error occurred';
    console.error('Error creating resource request:', message);
    return { success: false, error: message };
  }
}

